import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BannerFormLayer from "../components/BannerFormLayer";

const BannerAddPage = () => {
    return (
        <MasterLayout>
            <BannerFormLayer />
        </MasterLayout>
    );
};

export default BannerAddPage;
